"use strict";
/**
 * WP-079: Certificate types.
 *
 * Shared types for CPD completion certificates.
 * Consumed by:
 * - sync-server (CertificateRepository, endpoints)
 * - teacher-portal (CertificateViewer, certificatePdf)
 * - Downstream WPs: WP-084 (portfolio export), WP-086 (portable records)
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CERTIFICATE_VERIFICATION_STATUSES = void 0;
exports.isCertificateVerificationStatus = isCertificateVerificationStatus;
exports.CERTIFICATE_VERIFICATION_STATUSES = ['issued', 'revoked'];
function isCertificateVerificationStatus(v) {
    return typeof v === 'string' && exports.CERTIFICATE_VERIFICATION_STATUSES.includes(v);
}
